// Fetch independently of InstantSearch's current query, facets, and page.
export async function loadScheduleDocuments(client, collection, ids) {
  const documents = [];
  for (let offset = 0; offset < ids.length; offset += 100) {
    const batch = ids.slice(offset, offset + 100);
    if (batch.some((id) => /[`\\]/.test(id)))
      throw new Error('A session ID contains unsupported characters.');
    const result = await client
      .collections(collection)
      .documents()
      .search(
        {
          q: '*',
          filter_by: `id:=[${batch.map((id) => '`' + id + '`').join(',')}]`,
          per_page: 100,
        },
        { cacheSearchResultsForSeconds: 0 }
      );
    documents.push(...result.hits.map((hit) => hit.document));
  }
  return documents.sort(
    (a, b) =>
      Number(a.timestamp || 0) - Number(b.timestamp || 0) ||
      String(a.panel_title).localeCompare(String(b.panel_title))
  );
}
